<template>
  <b-navbar-item tag="div">
    <div v-if="!oidcUser" class="buttons">
      <a @click="signIn" class="button is-info">
        <strong>Sign in</strong>
      </a>
    </div>
    <b-dropdown v-else position="is-bottom-left" aria-role="menu">
      <a class="navbar-item" slot="trigger" role="button">
        <b-icon pack="fas" icon="user"></b-icon>
        <b-icon pack="fas" icon="caret-down"></b-icon>
      </a>

      <b-dropdown-item custom aria-role="menuitem">
        <b>{{ oidcUser.email }}</b>
      </b-dropdown-item>
      <hr class="dropdown-divider" />
      <b-dropdown-item value="tutors" aria-role="menuitem" has-link>
        <router-link to="/tutors">
          <div class="media">
            <b-icon
              class="media-left"
              pack="fas"
              icon="chalkboard-teacher"
            ></b-icon>
            <div class="media-content">
              Tutors
            </div>
          </div>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item value="students" aria-role="menuitem" has-link>
        <router-link to="/students">
          <div class="media">
            <b-icon class="media-left" pack="fas" icon="users"></b-icon>
            <div class="media-content">
              Students
            </div>
          </div>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item value="settings" aria-role="menuitem" has-link>
        <router-link to="/settings">
          <div class="media">
            <b-icon class="media-left" pack="fas" icon="cog"></b-icon>
            <div class="media-content">
              Settings
            </div>
          </div>
        </router-link>
      </b-dropdown-item>
      <b-dropdown-item value="logout" aria-role="menuitem" @click="signOut">
        <div class="media">
          <b-icon class="media-left" pack="fas" icon="sign-out-alt"></b-icon>
          <div class="media-content">
            Sign out
          </div>
        </div>
      </b-dropdown-item>
    </b-dropdown>
  </b-navbar-item>
</template>

<script>
import authMixin from "@/mixins/authMixin";
export default {
  mixins: [authMixin]
};
</script>

<style lang="scss" scoped></style>
